import {ExportDataRepo} from './ExportDataRepo'
import {
  ExportDataHistoryDTO,
  ExportDataHistoryJSON,
  ExportJobType
} from '../DTO/ExportDataHistoryDTO'
import {CommonResponseDTO, CommonResponseJSON} from '../../../../Network/CommonResponse'
import FetchWrapper from '../../../../Network/FetchWrapper'
import {Nullable} from '../../../../Common/TypeHelper'
import {ExportJob} from '../DTO/ExportJobDTO'
import {DTO} from '../../../../Common/DtoUtilities'
import {withAdminsAuth} from '../../../../Network/BrowserFetchWrapper'
import {ExportJobDownloadUrlDTO} from '../DTO/ExportJobDownloadUrlDTO'

export class NetworkExportDataRepo implements ExportDataRepo {
  private fetchWrapper: FetchWrapper
  private serverUrl = process.env.REACT_APP_MEMBUCKET_ADMIN_APP_SERVER_URL

  constructor(fetchWrapper: FetchWrapper) {
    this.fetchWrapper = fetchWrapper
  }

  postExportJob(
    exportJobType: ExportJobType,
    exportJob: ExportJob,
  ): Promise<CommonResponseDTO<Nullable<string>>> {
    return this.fetchWrapper.postJson(
      `${this.serverUrl}/v1/a/r/${exportJobType}/jobs`,
      DTO.toObject(exportJob),
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<Nullable<string>>) => {
      return new CommonResponseDTO(
        response.status,
        response.data,
        response.errorMessageList,
      )
    })
  }

  getExportDataHistory(
    exportJobType: ExportJobType,
    exportJobId: string,
    executeLongPolling: boolean,
  ): Promise<CommonResponseDTO<Nullable<ExportDataHistoryDTO>>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/${exportJobType}/jobs/${exportJobId}?long_polling=${executeLongPolling}`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<ExportDataHistoryJSON>) => {
      return CommonResponseDTO.from(
        response,
        ExportDataHistoryDTO.fromJSON,
      )
    })
  }

  getExportDataHistoryList(
    exportJobType: ExportJobType,
    bucketKey: string,
  ): Promise<CommonResponseDTO<Nullable<ExportDataHistoryDTO[]>>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/${exportJobType}/jobs?bucketKey=${bucketKey}`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<ExportDataHistoryJSON[]>) => {
      return CommonResponseDTO.fromArray(
        response,
        ExportDataHistoryDTO.fromJSON,
      )
    })
  }

  getExportFileRedirectUrl(
    downloadUrl: string,
  ): Promise<CommonResponseDTO<Nullable<ExportJobDownloadUrlDTO>>> {
    return this.fetchWrapper.getByJson(
      downloadUrl,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<ExportJobDownloadUrlDTO>) => {
      return CommonResponseDTO.from(
        response,
        ExportJobDownloadUrlDTO.fromJSON
      )
    })
  }

}
